// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datepicker {
  position: relative;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
}
.datepicker ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #999999;
}
.datepicker ::-moz-placeholder {
  /* Firefox 19+ */
  opacity: 1;
  color: #999999;
}
.datepicker :-ms-input-placeholder {
  /* IE 10+ */
  color: #999999;
}
.datepicker :-moz-placeholder {
  /* Firefox 18- */
  opacity: 1;
  color: #999999;
}
.datepicker.invalid {
  background-color: #ffe5e9;
  border: 1px solid #c30e2e;
}
.datepicker.invalid .input {
  background-color: #ffe5e9;
  color: #c30e2e;
}
.datepicker .clear-input {
  position: absolute;
  z-index: 5;
  bottom: 5px;
  right: 40px;
  height: 24px;
  width: 24px;
  background-image: url('cross.94f7db39b7176d24.svg');
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0;
}
.datepicker .clear-input:hover {
  background-image: url('cross-hover.51d99dd21ec0e20c.svg');
  cursor: pointer;
}
.datepicker .input {
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #d4cfbe;
  padding: 8px 11px 8px 11px;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
  position: relative;
}
.datepicker .input input {
  background-color: transparent;
  width: 100%;
  border: none;
  outline: none;
  cursor: inherit;
}
.datepicker .input input::-ms-clear {
  display: none;
}
.datepicker .input .button {
  transition: background-image 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  position: absolute;
  top: 8px;
  right: 11px;
  background-image: url('unselected-cal.e059ca7647f9d3ba.svg');
  border: none;
  height: 24px;
  width: 24px;
}
.datepicker .input .button.active {
  background-image: url('selected-cal.9603b1f4a14fbef4.svg');
}
.datepicker .input:hover:not(.disabled) {
  cursor: pointer;
}
.datepicker .input:hover:not(.disabled) .button {
  transition: background-image 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  background-image: url('selected-cal.9603b1f4a14fbef4.svg');
}
.datepicker .input:hover:not(.disabled) .clear-input {
  opacity: 1;
}
.datepicker .input .clear-input:focus {
  opacity: 1;
}
.datepicker .input.disabled {
  background-color: #f4f2ea;
}
.datepicker .calendar {
  z-index: 11;
  position: absolute;
  left: 0;
  width: 310px;
  min-height: 315px;
  background-color: #ffffff;
  margin-bottom: 80px;
}
.datepicker .calendar.visible {
  display: block;
  z-index: 20;
}
.datepicker .calendar .calendar-head {
  -webkit-user-select: none;
          user-select: none;
}
.datepicker .calendar .calendar-head .circle {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-color: #b39841;
  color: #ffffff;
  border-radius: 15px;
  position: relative;
}
.datepicker .calendar .calendar-head .circle .icon {
  width: 10px;
  height: 10px;
  position: absolute;
  left: 11px;
  top: 10px;
  border: 2px solid #ffffff;
  border-bottom: none;
  border-right: none;
  transform: rotate(-45deg);
}
.datepicker .calendar .calendar-head .circle .icon.fwd {
  left: 7px;
  transform: rotate(135deg);
}
.datepicker .calendar .calendar-head .circle:focus {
  outline: 2px solid #fd0 !important;
}
.datepicker .calendar .calendar-head .circle:hover,
.datepicker .calendar .calendar-head .circle:focus,
.datepicker .calendar .calendar-head .circle:active {
  cursor: pointer;
  background-color: #f4f2ea;
}
.datepicker .calendar .calendar-head .circle:hover .icon,
.datepicker .calendar .calendar-head .circle:focus .icon,
.datepicker .calendar .calendar-head .circle:active .icon {
  border-color: #b39841;
}
.datepicker .calendar .calendar-head .title {
  padding-top: 2px;
  width: 100%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  font-family: Montserrat-Semibold, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #b39841;
  margin-bottom: 3px;
}
.datepicker .calendar .calendar-body {
  font-family: Montserrat-Light, sans-serif;
  color: #444444;
  font-size: 15px;
  border-top: solid 1.5px #d4cfbe;
  margin: 7px 2px 0 2px;
  padding: 12px 2px 0 0;
}
.datepicker .calendar .calendar-body .day-label-container .day-label {
  width: 38px;
  height: 34px;
  float: left;
  text-align: center;
  margin: 0 2px 1px 0;
}
.datepicker .calendar .calendar-body .box-container .box {
  padding-top: 6px;
  width: 38px;
  height: 38px;
  background-color: #f4f2ea;
  border: 1px solid #F9F8F4;
  float: left;
  margin: 0 2px 1px 0;
  text-align: center;
}
.datepicker .calendar .calendar-body .box-container .box:hover {
  background-color: #b39841;
  border-color: #ffffff;
  color: #ffffff;
  cursor: pointer;
}
.datepicker .calendar .calendar-body .box-container .box.active {
  background-color: #b39841;
  border-color: #ffffff;
  color: #ffffff;
}
.datepicker .calendar .calendar-body .box-container .box.disabled {
  background-color: #f4f2ea;
  border: 1px solid #F9F8F4;
  color: #999999;
}
.datepicker ::ng-deep .dropdown-menu {
  max-height: 300px;
  overflow-y: scroll;
  margin: 0;
  padding: 0;
  top: 26px;
}
.datepicker ::ng-deep option:hover,
.datepicker ::ng-deep option:focus,
.datepicker ::ng-deep option:active {
  background-color: red !important;
}
.datepicker ::ng-deep .ngb-dp-header {
  display: none !important;
}
.datepicker ::ng-deep ngb-datepicker {
  border-top: none !important;
}
.datepicker ::ng-deep ngb-datepicker {
  top: 37px !important;
  left: 0 !important;
  margin-left: 8px;
  margin-bottom: 8px;
}
.datepicker ::ng-deep ngb-datepicker-month-view {
  width: 310px;
  min-height: 315px;
  padding: 9px 11px 14px 11px;
  background-color: #ffffff;
}
.datepicker ::ng-deep ngb-datepicker-month-view .ngb-dp-arrow {
  font-weight: 400;
  color: #b39841;
  border-radius: 0;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day {
  height: 38px;
  width: 38px;
  background-color: #f4f2ea;
  margin: 0 3px 2px 0;
}
.datepicker ::ng-deep ngb-datepicker .ngb-dp-day.hidden {
  display: block !important;
  background-color: transparent !important;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day ::ng-deep .btn-light {
  height: 38px;
  width: 38px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day ::ng-deep .btn-light:hover,
.datepicker .btn-light.range {
  background-color: #7F6C2E;
  color: #ffffff;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day ::ng-deep .btn-light:focus {
  background-color: #b39841;
  color: #ffffff;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day ::ng-deep .btn-light.faded {
  background-color: #b39841;
  color: #ffffff;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day ::ng-deep .btn-light.text-muted {
  color: #999999;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-weekday {
  height: 30px;
  width: 40px;
  font-family: Montserrat-Light, sans-serif;
  color: #444444;
  font-size: 15px;
  font-style: normal;
}
.datepicker ::ng-deep ngb-datepicker-navigation {
  height: 40px;
  margin-bottom: 10px;
}
.datepicker ::ng-deep ngb-datepicker-month-view ::ng-deep .ngb-dp-weekdays {
  border-bottom: none !important;
  border-top: solid 1.5px #d4cfbe !important;
  padding-top: 10px !important;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep ngb-datepicker-navigation ::ng-deep :focus {
  box-shadow: none !important;
  outline: none !important;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-months ::ng-deep :focus {
  outline-color: #b39841;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep select {
  border: 1px solid #d4cfbe;
  background-color: #ffffff;
  min-height: 40px;
  padding: 0 30px 0 9px;
  display: flex;
  position: relative;
  cursor: pointer;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px !important;
  color: #444444;
  width: 100%;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep ngb-datepicker-navigation {
  margin-top: 20px;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep ngb-datep icker-navigation-select ::ng-deep select:nth-child(1) {
  margin-right: 10px !important;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep ngb-datepicker-navigation-select ::ng-deep select:focus {
  border: 1px solid #b39841 !important;
}
.datepicker ::ng-deep ngb-datepicker ::ng-deep .bg-primary {
  color: white;
  background-color: #b39841;
}
.ngb-dp-arrow {
  font-weight: 400;
  color: #b39841;
  border-radius: 0;
}
.ngb-dp-arrow {
  display: inline-block;
  width: 30px !important;
  height: 30px !important;
  background-color: #b39841;
  color: #ffffff;
  border-radius: 15px;
  position: relative;
  flex: unset !important;
  outline: none !important;
  box-shadow: none !important;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .ngb-dp-arrow {
    flex-grow: 0 !important;
  }
}
.ngb-dp-arrow button {
  height: 30px !important;
  width: 30px !important;
  border-radius: 15px !important;
  margin: 0 !important;
}
.ngb-dp-arrow button {
  color: #ffffff;
}
.ngb-dp-arrow button:focus {
  color: #b39841;
  background-color: #f4f2ea;
}
.ngb-dp-arrow button:hover {
  color: #b39841;
  background-color: #f4f2ea;
}
.datepicker ::ng-deep select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000000;
}
.datepicker ::ng-deep select:focus::-ms-value {
  color: #444444;
  background-color: transparent;
}
.datepicker ::ng-deep select {
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  display: inline-block;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #d4cfbe;
  padding-left: 15px;
  padding-right: 40px;
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
  background-position: right 9px top 7px;
  background-repeat: no-repeat;
  font-family: "Montserrat-Light", sans-serif;
  font-size: 15px;
}
.datepicker ::ng-deep select.disabled,
.datepicker ::ng-deep select[disabled] {
  background-color: #bfbbaa;
  border-color: #bfbbaa;
  color: #777777;
  background-image: url('closed-chev-big-disabled.1ee371182a4805cb.svg');
}
.datepicker ::ng-deep select ::ng-deep option {
  outline: none;
  padding: 5px;
  border: 1px solid #d4cfbe;
  background-color: #ffffff;
  font-size: 15px;
  font-family: "Montserrat-Light", sans-serif;
}
.calendar-head {
  background-color: white;
  width: 312px;
  border: 1px solid #cccccc;
  border-bottom: none !important;
}
.calender-navigate {
  height: 35px;
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
.calendar-month {
  margin-top: 10px;
  height: 25px;
}
.inline-div {
  display: inline-block;
}
.calender-navigate ::ng-deep .show {
  display: inline-block !important;
}
.calender-navigate .dropdown-menu {
  display: inline-block !important;
  min-width: 100px;
  left: 10px;
  top: 34px;
}
.d-inline-block ::ng-deep .dropdown {
  display: inline-block;
}
.d-inline-block ::ng-deep .dropdown ::ng-deep button {
  border-radius: 0;
  background-color: white;
  border: 1px solid #d4cfbe;
  width: 90px;
  margin-right: 5px;
  margin-left: 10px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 15px;
}
.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button {
  width: 100%;
  margin: 0;
  min-height: 34px;
  border: none;
  text-align: left;
  padding-left: 12px;
}
.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:hover,
.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:active,
.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:focus,
.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button.selected {
  background-color: #7F6C2E;
  color: white;
}
::ng-deep .dropdown-toggle {
  outline: none !important;
  box-shadow: none !important;
}
.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:hover,
.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:active,
.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:focus {
  border: 1px solid #7F6C2E !important;
}
.calender-navigate .circle:hover,
.calender-navigate .circle:focus,
.calender-navigate .circle:active {
  outline: none !important;
  box-shadow: none !important;
}
.dropdown-menu {
  opacity: 0;
  z-index: -20;
}
.inline-div .showDropDown {
  opacity: 1;
  z-index: 20;
}
.collapse {
  display: block;
  width: 23px;
  height: 23px;
  float: right;
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
}
.collapse.active {
  background-image: url('open-chev-big.f05d398ec6e57c90.svg');
}
.collapse:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/datepicker/datepicker.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,yCAAA;EACA,eAAA;AADJ;AAFA;EAIE,wBAAwB;EAElB,cAAA;AAAR;AANA;EAQE,gBAAgB;EACV,UAAA;EACA,cAAA;AACR;AAXA;EAaE,WAAW;EAAL,cAAA;AAER;AAfA;EAiBE,gBAAgB;EADV,UAAA;EACA,cAAA;AAGR;AAAI;EACI,yBAAA;EACA,yBAAA;AAER;AAJI;EAKQ,yBAAA;EACA,cAAA;AAEZ;AA5BA;EA+BQ,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,UAAA;AAAR;AAEQ;EACI,yDAAA;EACA,eAAA;AAAZ;AA5CA;EAiDQ,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;AAFR;AArDA;EA0DY,6BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AA/DA;EAsEY,qEAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAJZ;AAMY;EACI,0DAAA;AAJhB;AAQQ;EACI,eAAA;AANZ;AAKQ;EAIQ,qEAAA;EACA,0DAAA;AANhB;AACQ;EASQ,UAAA;AAPhB;AAtFA;EAkGY,UAAA;AATZ;AAYQ;EACI,yBAAA;AAVZ;AA5FA;EA2GQ,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAZR;AAcQ;EACI,cAAA;EACA,WAAA;AAZZ;AAzGA;EAyHY,yBAAA;UAAA,iBAAA;AAbZ;AA5GA;EA4HgB,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAbhB;AArHA;EAqIoB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAbpB;AAeoB;EACI,SAAA;EACA,yBAAA;AAbxB;AAiBgB;EACE,kCAAA;AAflB;AAiBgB;;;EACI,eAAA;EACA,yBAAA;AAbpB;AAWgB;;;EAKQ,qBAAA;AAXxB;AAlJA;EAmKgB,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAdhB;AA9JA;EAiLY,yCAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,qBAAA;EACA,qBAAA;AAhBZ;AAtKA;EA0LoB,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAjBpB;AA7KA;EAoMoB,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AApBpB;AAsBoB;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AApBxB;AAuBoB;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;AArBxB;AAwBoB;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;AAtBxB;AA+BA;EAEI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AA9BJ;AAwBA;;;EAYM,gCAAA;AA/BN;AAmBA;EAgBM,wBAAA;AAhCN;AAgBA;EAoBI,2BAAA;AAjCJ;AAaA;EAwBM,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAlCN;AAOA;EA+BM,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;AAnCN;AACA;EAqCU,gBAAA;EACA,cAAA;EACA,gBAAA;AAnCV;AAJA;EA4CM,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AArCN;AAVA;EAmDI,yBAAA;EACA,wCAAA;AAtCJ;AAdA;EA+DM,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA9CN;AArBA;;EA8EM,yBAAA;EACA,cAAA;AArDN;AA1BA;EA0FM,yBAAA;EACA,cAAA;AA7DN;AA9BA;EAsGM,yBAAA;EACA,cAAA;AArEN;AAlCA;EAkHM,cAAA;AA7EN;AArCA;EAsHM,YAAA;EACA,WAAA;EACA,yCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA9EN;AA7CA;EA+HM,YAAA;EACA,mBAAA;AA/EN;AAjDA;EAoIM,8BAAA;EACA,0CAAA;EACA,4BAAA;AAhFN;AAtDA;EA0II,2BAAA;EACA,wBAAA;AAjFJ;AA1DA;EA+IM,sBAAA;AAlFN;AA7DA;EAmJM,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;EACA,0BAAA;EACA,cAAA;EACA,WAAA;AAnFN;AA1EA;EAiKM,gBAAA;AApFN;AA7EA;EA2KM,6BAAA;AA3FN;AAhFA;EAoLM,oCAAA;AAjGN;AAnFA;EAwLM,YAAA;EACA,yBAAA;AAlGN;AAuGA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AArGJ;AAwGA;EACI,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;AAtGJ;AAyGA;EAvGE,6BAA6B;EAyG3B;IAEI,uBAAA;EAvGN;AACF;AA0GA;EACI,uBAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;AAxGJ;AA2GA;EACI,cAAA;AAzGJ;AA4GA;EACI,cAAA;EACA,yBAAA;AA1GJ;AA6GA;EACI,cAAA;EACA,yBAAA;AA3GJ;AA8GA;EAEQ,kBAAA;EACA,0BAAA;AA7GR;AA0GA;EAOQ,cAAA;EACA,6BAAA;AA9GR;AAsGA;EAYQ,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,sCAAA;EACA,4BAAA;EACA,2CAAA;EACA,eAAA;AA/GR;AAiHQ;;EAEI,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,sEAAA;AA/GZ;AA+EA;EAoCY,aAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,2CAAA;AAhHZ;AAqHA;EACI,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;AAnHJ;AAsHA;EACI,YAAA;EACA,gBAAA;EACF,aAAA;EACA,6BAAA;AApHF;AAuHA;EACI,gBAAA;EACA,YAAA;AArHJ;AAwHA;EACI,qBAAA;AAtHJ;AAyHA;EACI,gCAAA;AAvHJ;AA0HA;EACI,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAxHJ;AA2HA;EACI,qBAAA;AAzHJ;AA4HA;EACI,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,2DAAA;EACA,eAAA;AA1HJ;AA6HA;EACI,WAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA3HJ;AA8HA;;;;EAII,yBAAA;EACA,YAAA;AA5HJ;AA+HA;EACI,wBAAA;EACA,2BAAA;AA7HJ;AAgIA;;;EAGI,oCAAA;AA9HJ;AAiIA;;;EAGI,wBAAA;EACA,2BAAA;AA/HJ;AAkIA;EACI,UAAA;EACA,YAAA;AAhIJ;AAmIA;EACI,UAAA;EACA,WAAA;AAjIJ;AAoIA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6DAAA;AAlIJ;AAoII;EACI,2DAAA;AAlIR;AAqII;EACI,eAAA;AAnIR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.datepicker {\n    position: relative;\n    font-family: Montserrat-Light, sans-serif;\n    font-size: 15px;\n\n    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n        color: @secondary-60;\n    }\n    ::-moz-placeholder { /* Firefox 19+ */\n        opacity: 1;\n        color: @secondary-60;\n    }\n    :-ms-input-placeholder { /* IE 10+ */\n        color: @secondary-60;\n    }\n    :-moz-placeholder { /* Firefox 18- */\n        opacity: 1;\n        color: @secondary-60;\n    }\n\n    &.invalid {\n        background-color: @invalid-fill;\n        border: 1px solid @invalid-outline;\n\n        .input {\n            background-color: @invalid-fill;\n            color: @invalid-outline;\n        }\n    }\n\n    .clear-input {\n        position: absolute;\n        z-index: 5;\n        bottom: 5px;\n        right: 40px;\n        height: 24px;\n        width: 24px;\n        background-image: url(\"../../styles/img/cross.svg\");\n        background-repeat: no-repeat;\n        background-position: center;\n        opacity: 0;\n\n        &:hover {\n            background-image: url(\"../../styles/img/cross-hover.svg\");\n            cursor: pointer;\n        }\n    }\n\n    .input {\n        height: 40px;\n        background-color: @white;\n        border: 1px solid @primary-50;\n        padding: 8px 11px 8px 11px;\n        font-family: Montserrat-Light, sans-serif;\n        font-size: 15px;\n        position: relative;\n\n        input {\n            background-color: transparent;\n            width: 100%;\n            border: none;\n            outline: none;\n            cursor: inherit;\n\n            &::-ms-clear {\n                display: none;\n            }\n        }\n\n        .button {\n            transition: background-image 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n            position: absolute;\n            top: 8px;\n            right: 11px;\n            background-image: url(\"../../styles/img/unselected-cal.svg\");\n            border: none;\n            height: 24px;\n            width: 24px;\n\n            &.active {\n                background-image: url(\"../../styles/img/selected-cal.svg\");\n            }\n        }\n\n        &:hover:not(.disabled) {\n            cursor: pointer;\n\n            .button {\n                transition: background-image 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n                background-image: url(\"../../styles/img/selected-cal.svg\");\n            }\n\n            .clear-input {\n                opacity: 1;\n            }\n        }\n\n        .clear-input:focus {\n            opacity: 1;\n        }\n\n        &.disabled {\n            background-color: @primary-40;\n        }\n    }\n\n    .calendar {\n        z-index: 11;\n        position: absolute;\n        left: 0;\n        width: 310px;\n        min-height: 315px;\n        background-color: @white;\n        margin-bottom: 80px;\n\n        &.visible {\n            display: block;\n            z-index: 20;\n        }\n\n        .calendar-head {\n            user-select: none;\n\n            .circle {\n                display: inline-block;\n                width: 30px;\n                height: 30px;\n                background-color: @primary-90;\n                color: @white;\n                border-radius: 15px;\n                position: relative;\n\n                .icon {\n                    width: 10px;\n                    height: 10px;\n                    position: absolute;\n                    left: 11px;\n                    top: 10px;\n                    border: 2px solid @white;\n                    border-bottom: none;\n                    border-right: none;\n                    transform: rotate(-45deg);\n\n                    &.fwd {\n                        left: 7px;\n                        transform: rotate(135deg);\n                    }\n                }\n\n                &:focus {\n                  outline: 2px solid @focus-outline !important;\n                }\n                &:hover, &:focus, &:active {\n                    cursor: pointer;\n                    background-color: @primary-40;\n\n                    .icon {\n                        border-color: @primary-90;\n                    }\n                }\n            }\n\n            .title {\n                padding-top: 2px;\n                width: 100%;\n                display: inline-block;\n                vertical-align: top;\n                text-align: center;\n                font-family: Montserrat-Semibold, sans-serif;\n                font-size: 20px;\n                font-weight: 600;\n                color: @primary-90;\n                margin-bottom: 3px;\n            }\n        }\n\n        .calendar-body {\n            font-family: Montserrat-Light, sans-serif;\n            color: @secondary-90;\n            font-size: 15px;\n            border-top: solid 1.5px @primary-50;\n            margin: 7px 2px 0 2px;\n            padding: 12px 2px 0 0;\n\n            .day-label-container {\n                .day-label {\n                    width: 38px;\n                    height: 34px;\n                    float: left;\n                    text-align: center;\n                    margin: 0 2px 1px 0;\n                }\n            }\n\n            .box-container {\n                .box {\n                    padding-top: 6px;\n                    width: 38px;\n                    height: 38px;\n                    background-color: @primary-40;\n                    border: 1px solid @primary-30;\n                    float: left;\n                    margin: 0 2px 1px 0;\n                    text-align: center;\n\n                    &:hover {\n                        background-color: @primary-90;\n                        border-color: @white;\n                        color: @white;\n                        cursor: pointer;\n                    }\n\n                    &.active {\n                        background-color: @primary-90;\n                        border-color: @white;\n                        color: @white;\n                    }\n\n                    &.disabled {\n                        background-color: @primary-40;\n                        border: 1px solid @primary-30;\n                        color: @secondary-60;\n                        //cursor: default;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.datepicker {\n  ::ng-deep .dropdown-menu {\n    max-height: 300px;\n    overflow-y: scroll;\n    margin: 0;\n    padding: 0;\n    top: 26px;\n  }\n\n  ::ng-deep option:hover,\n  ::ng-deep option:focus,\n  ::ng-deep option:active {\n      background-color: red !important;\n  }\n\n  ::ng-deep .ngb-dp-header {\n      display: none !important;\n  }\n\n  ::ng-deep ngb-datepicker {\n    border-top: none !important;\n  }\n\n  ::ng-deep ngb-datepicker {\n      top: 37px !important;\n      left: 0 !important;\n      margin-left: 8px;\n      margin-bottom: 8px;\n  }\n\n  ::ng-deep ngb-datepicker-month-view {\n      width: 310px;\n      min-height: 315px;\n      padding: 9px 11px 14px 11px;\n      background-color: @white;\n\n      .ngb-dp-arrow {\n          font-weight: 400;\n          color: @primary-90;\n          border-radius: 0;\n      }\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-day {\n      height: 38px;\n      width: 38px;\n      background-color: @primary-40;\n      margin: 0 3px 2px 0;\n  }\n\n  ::ng-deep ngb-datepicker .ngb-dp-day.hidden {\n    display: block !important;\n    background-color: transparent !important;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  .ngb-dp-week\n  ::ng-deep\n  .ngb-dp-day\n  ::ng-deep\n  .btn-light {\n      height: 38px;\n      width: 38px;\n      display: table-cell;\n      vertical-align: middle;\n      text-align: center;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  .ngb-dp-week\n  ::ng-deep\n  .ngb-dp-day\n  ::ng-deep\n  .btn-light:hover, .btn-light.range {\n      background-color: @primary-base;\n      color: @white;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  .ngb-dp-week\n  ::ng-deep\n  .ngb-dp-day\n  ::ng-deep\n  .btn-light:focus {\n      background-color: @primary-90;\n      color: @white;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  .ngb-dp-week\n  ::ng-deep\n  .ngb-dp-day\n  ::ng-deep\n  .btn-light.faded {\n      background-color: @primary-90;\n      color: @white;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  .ngb-dp-week\n  ::ng-deep\n  .ngb-dp-day\n  ::ng-deep\n  .btn-light.text-muted {\n      color: @secondary-60;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-week ::ng-deep .ngb-dp-weekday {\n      height: 30px;\n      width: 40px;\n      font-family: Montserrat-Light, sans-serif;\n      color: @secondary-90;\n      font-size: 15px;\n      font-style: normal;\n  }\n\n  ::ng-deep ngb-datepicker-navigation {\n      height: 40px;\n      margin-bottom: 10px;\n  }\n\n  ::ng-deep ngb-datepicker-month-view ::ng-deep .ngb-dp-weekdays {\n      border-bottom: none !important;\n      border-top: solid 1.5px @primary-50 !important;\n      padding-top: 10px !important;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep ngb-datepicker-navigation ::ng-deep :focus {\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep .ngb-dp-months ::ng-deep :focus {\n      outline-color: @primary-90;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep select {\n      border: 1px solid @primary-50;\n      background-color: @white;\n      min-height: 40px;\n      padding: 0 30px 0 9px;\n      display: flex;\n      position: relative;\n      cursor: pointer;\n      font-family: Montserrat-Light, sans-serif;\n      font-size: 15px !important;\n      color: @secondary-90;\n      width: 100%;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep ngb-datepicker-navigation {\n      margin-top: 20px;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  ngb-datep\n  icker-navigation-select\n  ::ng-deep\n  select:nth-child(1) {\n      margin-right: 10px !important;\n  }\n\n  ::ng-deep\n  ngb-datepicker\n  ::ng-deep\n  ngb-datepicker-navigation-select\n  ::ng-deep\n  select:focus {\n      border: 1px solid @primary-90 !important;\n  }\n\n  ::ng-deep ngb-datepicker ::ng-deep .bg-primary {\n      color: white;\n      background-color: @primary-90;\n  }\n\n}\n\n.ngb-dp-arrow {\n    font-weight: 400;\n    color: @primary-90;\n    border-radius: 0;\n}\n\n.ngb-dp-arrow {\n    display: inline-block;\n    width: 30px !important;\n    height: 30px !important;\n    background-color: @primary-90;\n    color: @white;\n    border-radius: 15px;\n    position: relative;\n    flex: unset !important;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    /* IE10+ CSS styles go here */\n    .ngb-dp-arrow {\n        -ms-flex-positive: 0 !important;\n        flex-grow: 0 !important;\n    }\n}\n\n.ngb-dp-arrow button {\n    height: 30px !important;\n    width: 30px !important;\n    border-radius: 15px !important;\n    margin: 0 !important;\n}\n\n.ngb-dp-arrow button {\n    color: @white;\n}\n\n.ngb-dp-arrow button:focus {\n    color: @primary-90;\n    background-color: @primary-40;\n}\n\n.ngb-dp-arrow button:hover {\n    color: @primary-90;\n    background-color: @primary-40;\n}\n\n.datepicker {\n    ::ng-deep select:-moz-focusring {\n        color: transparent;\n        text-shadow: 0 0 0 @black;\n    }\n\n    ::ng-deep select:focus::-ms-value {\n        color: @secondary-90;\n        background-color: transparent;\n    }\n\n    ::ng-deep select {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        outline: none;\n        display: inline-block;\n        height: 40px;\n        background-color: @white;\n        border: 1px solid @primary-50;\n        padding-left: 15px;\n        padding-right: 40px;\n        background-image: url(\"../../styles/img/closed-chev-big.svg\");\n        background-position: right 9px top 7px;\n        background-repeat: no-repeat;\n        font-family: \"Montserrat-Light\", sans-serif;\n        font-size: 15px;\n\n        &.disabled,\n        &[disabled] {\n            background-color: @disabled-fill;\n            border-color: @disabled-fill;\n            color: @placeholder;\n            background-image: url(\"../../styles/img/closed-chev-big-disabled.svg\");\n        }\n\n        ::ng-deep option {\n            outline: none;\n            padding: 5px;\n            border: 1px solid @primary-50;\n            background-color: @white;\n            font-size: 15px;\n            font-family: \"Montserrat-Light\", sans-serif;\n        }\n    }\n}\n\n.calendar-head {\n    background-color: white;\n    width: 312px;\n    border: 1px solid @secondary-30;\n    border-bottom: none !important;\n}\n\n.calender-navigate {\n    height: 35px;\n    margin-top: 10px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.calendar-month {\n    margin-top: 10px;\n    height: 25px;\n}\n\n.inline-div {\n    display: inline-block;\n}\n\n.calender-navigate ::ng-deep .show {\n    display: inline-block !important;\n}\n\n.calender-navigate .dropdown-menu {\n    display: inline-block !important;\n    min-width: 100px;\n    left: 10px;\n    top: 34px;\n}\n\n.d-inline-block ::ng-deep .dropdown {\n    display: inline-block;\n}\n\n.d-inline-block ::ng-deep .dropdown ::ng-deep button {\n    border-radius: 0;\n    background-color: white;\n    border: 1px solid @primary-50;\n    width: 90px;\n    margin-right: 5px;\n    margin-left: 10px;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 15px;\n}\n\n.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button {\n    width: 100%;\n    margin: 0;\n    min-height: 34px;\n    border: none;\n    text-align: left;\n    padding-left: 12px;\n}\n\n.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:hover,\n.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:active,\n.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button:focus,\n.d-inline-block ::ng-deep .dropdown-menu ::ng-deep button.selected {\n    background-color: @primary-base;\n    color: white;\n}\n\n::ng-deep .dropdown-toggle {\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:hover,\n.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:active,\n.d-inline-block ::ng-deep ::ng-deep .dropdown-toggle:focus {\n    border: 1px solid @primary-base !important;\n}\n\n.calender-navigate .circle:hover,\n.calender-navigate .circle:focus,\n.calender-navigate .circle:active {\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.dropdown-menu {\n    opacity: 0;\n    z-index: -20;\n}\n\n.inline-div .showDropDown {\n    opacity: 1;\n    z-index: 20;\n}\n\n.collapse {\n    display: block;\n    width: 23px;\n    height: 23px;\n    float: right;\n    background-image: url(\"../../styles/img/closed-chev-big.svg\");\n\n    &.active {\n        background-image: url(\"../../styles/img/open-chev-big.svg\");\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
